import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  article?: {
    publishedTime?: string;
    modifiedTime?: string;
    tags?: string[];
  };
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage, article }: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);

    const baseUrl = 'https://4688.tv';
    const fullUrl = canonicalUrl ? `${baseUrl}${canonicalUrl}` : baseUrl;
    const canonicalEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonicalEl) canonicalEl.setAttribute('href', fullUrl);

    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:url', fullUrl, true);
    setMeta('og:type', ogType, true);
    if (ogImage) setMeta('og:image', ogImage, true);
    setMeta('og:site_name', '4688.tv', true);
    setMeta('og:locale', 'zh_CN', true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);

    if (article) {
      if (article.publishedTime) setMeta('article:published_time', article.publishedTime);
      if (article.modifiedTime) setMeta('article:modified_time', article.modifiedTime);
      if (article.tags) {
        article.tags.forEach((tag) => {
          let el = document.querySelector(`meta[property="article:tag"][content="${tag}"]`);
          if (!el) {
            el = document.createElement('meta');
            el.setAttribute('property', 'article:tag');
            el.setAttribute('content', tag);
            document.head.appendChild(el);
          }
        });
      }
    }
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, article]);

  return null;
}